
// Set the dayjs date to the given time ( received in HH:mm format )
export const setTimeOfDate = (date, time) => {
  const [hours, minutes] = time.split(":");
  return date.set("hour", parseInt(hours)).set("minute", parseInt(minutes));
};
